<template>
  <div id="pageRoot">
    <div style="position: absolute; width: 630px; height: 300px; left: 40px; top: 60px; z-index: 2" class="hover-animation-a">
		<p class="textBase centerH" style="position: absolute; width: 450px; font-weight: 1000; font-size: 33px; top: 100px">¿QUIÉN PERDIÓ EL VIOLÍN?</p>
		<p class="textBase centerH" style="position: absolute; width: 480px; font-size: 27px; top: 150px; text-align: center;">NEGRO ES, A VECES MARRÓN.<br>POR LOS RINCONES TOCA EL VIOLÍN. SI MIRÁS CON ATENCIÓN,<br>PODRÁS ENCONTRARLO.</p>
		<img src="/pages/img/sordovio/assets_p2/etiqueta.svg" style="position: absolute; width: 100%; z-index: 1"/>
    </div>

    <img src="/pages/img/sordovio/assets_p2/mancha.svg" style="position: absolute; width: 800px; top: 110px; left: 70px; z-index: 0"  class="slideItemB"/>

    <img src="/pages/img/sordovio/assets_p2/arboles.svg" style="position: absolute; width: 340px; top: 440px; left: 70px; z-index: 0"  class="slideItem"/>

     <img src="/pages/img/sordovio/assets_p2/zorrito.svg" style="position: absolute; width: 390px; top: 310px; left: 520px; z-index: 3"  class="basicItem02"/>

  </div>
</template>
<style scoped>
#bg{
    position: absolute;
    left: 35px;
    top: 50px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["vio/Video 2.mp4"]
    }
  }
}
</script>